import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

export const ButtonWrapper = styled.div`
    white-space: nowrap;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 20px;
`;

export const DateText = styled.p`
    ${styledTypography.allianceBase};
    margin: 2px 0;
    color: ${({ theme }) => theme.shades.white[70]};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    span {
        align-self: flex-end;
        font-weight: 600;
        color: ${({ theme }) => theme.shades.white[60]};
    }
`;
